import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"];

  modalTargetConnected(modal) {
    if (modal.style.display === "flex" || modal.classList.contains("show")) {
      this.activeModal = modal;
    }
  }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this);
    this.activeModal = null;

    if (this.element.dataset.autoOpen === "true") {
      this.showModal(this.findModal(this.element.dataset.autoOpenType));
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleKeydown);

    if (!document.querySelector(".custom-modal-backdrop.show")) {
      document.body.classList.remove("modal-open");
    }
  }

  open(event) {
    this.showModal(this.findModal(event?.currentTarget?.dataset?.modalType));
  }

  findModal(type) {
    if (!type) return this.modalTarget;
    return (
      this.modalTargets.find((m) => m.dataset.modalType === type) ||
      this.modalTarget
    );
  }

  showModal(modal) {
    this.activeModal = modal;
    modal.classList.add("show");
    modal.style.display = "flex";
    document.body.classList.add("modal-open");

    document.addEventListener("keydown", this.boundHandleKeydown);
  }

  close() {
    const modal = this.activeModal || this.modalTarget;

    modal.classList.remove("show");
    modal.style.display = "none";
    document.body.classList.remove("modal-open");

    document.removeEventListener("keydown", this.boundHandleKeydown);
    this.activeModal = null;
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }
}
